import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import logo from '../../media/logo.png';
import marioMeloPhoto from '../../media/testimonials/mario-melo.png';
import emmanuelRicciPhoto from '../../media/testimonials/emmanuel-ricci.png';
import remerosBeachPhoto from '../../media/testimonials/remeros-beach.png';
import nataliaCalvetePhoto from '../../media/testimonials/natalia-calvete.png';
import sebastianGregoracePhoto from '../../media/testimonials/sebastian-gregorace.png';
import fernandoCastroPhoto from '../../media/testimonials/fernando-castro.png';
import estebanTognocchiPhoto from '../../media/testimonials/esteban-tognocchi.png';
import andresZukerPhoto from '../../media/testimonials/andres-zuker.png';

const testimonials = [
  // ... (Testimonios omitidos por brevedad)
  {
    "text": "Son excelentes súper recomendado",
    "name": "Construcción Mario Melo",
    "role": null,
    "logo": marioMeloPhoto
  },
  {
    "text": "Muy buena empresa de servicios audiovisuales",
    "name": "Emmanuel Ricci",
    "role": null,
    "logo": emmanuelRicciPhoto
  },
  {
    "text": "Junto con la empresa instalamos una torre en nuestro proyecto que nos permite documentar el avance de nuestra obra, el sistema que han desarrollado es exclente!!",
    "name": "Remeros Beach",
    "role": null,
    "logo": remerosBeachPhoto
  },
  {
    "text": "Excelente atención, tanto del equipo comercial como técnico, estamos sumamente conformes con los resultados, gracias.",
    "name": "Natalia Calvete",
    "role": null,
    "logo": nataliaCalvetePhoto
  },
  {
    "text": "Hemos realizado varios trabajos con la productora y queremos destacar su gran profesionalismo, compromiso y calidad con la que trabajan. Muchas gracias por los excelentes servicios!",
    "name": "Sebastian Gregorace",
    "role": null,
    "logo": sebastianGregoracePhoto
  },
  {
    "text": "Los contacte por una recomendación y realizaron un Excelente trabajo. Muy buena atención. Los voy a recomendar!!!",
    "name": "Fernando castro",
    "role": null,
    "logo": fernandoCastroPhoto
  },
  {
    "text": "Excelente! Fueron muy claros desde el comienzo para explicarnos como trabajan e hicieron todo lo que estaba a su alcance para que el evento que tenían que cubrir fuera tal como lo habíamos planeado. Lo recomendamos! Muchas gracias!!",
    "name": "Esteban Tognocchi",
    "role": null,
    "logo": estebanTognocchiPhoto
  },
  {
    "text": "Con Lisual encontramos nuestros socios comerciales perfectos. Comparten los mismos valores que tenemos como empresa. Profesionales, vanguardistas y sobre todo responsables. El 100% de nuestra cartera está relevada por ellos. Creemos en el largo plazo, por eso seguimos eligiendo al equipo de Lisual.",
    "name": "Andres Zuker",
    "role": null,
    "logo": andresZukerPhoto
  }
]

const Carousel = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const cardVariants = {
    initial: { x: "100%", opacity: 0 },
    animate: { x: "0%", opacity: 1 },
    exit: { x: "-100%", opacity: 0 },
  };

  return (
    // Altura del carrusel: h-64 en mobile, md:h-80 en web.
    <div className="relative w-full h-64 md:h-80 overflow-hidden flex items-center justify-center">
      <AnimatePresence initial={false} mode="wait">
        <motion.div
          key={current}
          variants={cardVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{
            x: { type: "spring", stiffness: 300, damping: 30 },
            opacity: { duration: 0.5 }
          }}
          // Padding de la tarjeta: p-6 en mobile, md:p-8 en web.
          className="absolute w-full p-6 md:p-8 bg-white rounded-lg shadow-lg text-gray-800"
        >
          <div className="flex mb-4">
            {[...Array(5)].map((_, i) => (
              <i key={i} className="fas fa-star text-yellow-400 mr-1"></i>
            ))}
          </div>
          <blockquote className="mt-4">
            {/* AJUSTE CLAVE DE TEXTO: Reducimos a text-xs en mobile para forzar la entrada, sm:text-lg en web. */}
            <p className="text-xs sm:text-lg font-bold">"{testimonials[current].text}"</p>
            <div className="mt-4 flex items-center justify-between">
              <div className="flex items-center">
                <div className="mr-3">
                  {/* TAMAÑO DE IMAGEN Y AJUSTE DE OBJETO: w-12 h-12 y se añade `object-cover` para evitar la deformación. */}
                  <img
                    className="w-12 h-12 md:w-16 md:h-16 rounded-full object-cover"
                    src={testimonials[current].logo}
                    alt={testimonials[current].name}
                    onError={(e) => { e.currentTarget.src = logo; }}
                  />
                </div>
                <div>
                  <p className="font-bold">{testimonials[current].name}</p>
                  <p className="text-xs sm:text-sm text-gray-500">{testimonials[current].role}</p>
                </div>
              </div>
              <img className="h-auto max-w-[80px] sm:max-w-[100px]" src={logo} alt="Logo de la empresa" />
            </div>
          </blockquote>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default Carousel;